import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerDashboardInquiryList,
	formatWorkerDashboardNoticeList,
	formatWorkerDashboardNoticeReceiveList,
	formatWorkerDashboardStatistic,
	formatWorkerDashboardUseTipList,
} from './worker-dashboard.helper';
import { WorkerDashboardActions } from './worker-dashboard.redux';
import {
	IPayloadGetWorkerDashboardInquiryListRequest,
	IPayloadGetWorkerDashboardNoticeListRequest,
	IPayloadGetWorkerDashboardNoticeReceiveListRequest,
	IPayloadGetWorkerDashboardStatisticRequest,
	IPayloadGetWorkerDashboardUseTipListRequest,
} from './worker-dashboard.type';

export function* getWorkerDashboardStatistic(
	action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardStatisticResponse> =
			yield API.getWorkerDashboardStatistic(rest);
		const workerDashboardStatistic = formatWorkerDashboardStatistic(res?.data);

		yield put(
			WorkerDashboardActions.getWorkerDashboardStatisticSuccess({
				workerDashboardStatistic,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDashboardActions.getWorkerDashboardStatisticFailure());
	}
}

export function* getWorkerDashboardNoticeList(
	action: PayloadAction<IPayloadGetWorkerDashboardNoticeListRequest>
) {
	const { callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardNoticeListResponse> =
			yield API.getWorkerDashboardNotice();
		const content = formatWorkerDashboardNoticeList(res?.data);

		yield put(
			WorkerDashboardActions.getWorkerDashboardNoticeListSuccess({
				content,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDashboardActions.getWorkerDashboardNoticeListFailure());
	}
}

export function* getWorkerDashboardInquiryList(
	action: PayloadAction<IPayloadGetWorkerDashboardInquiryListRequest>
) {
	const { callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardInquiryListResponse> =
			yield API.getWorkerDashboardInquiry();
		const content = formatWorkerDashboardInquiryList(res?.data);

		yield put(
			WorkerDashboardActions.getWorkerDashboardInquiryListSuccess({
				content,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDashboardActions.getWorkerDashboardInquiryListFailure());
	}
}

export function* getWorkerDashboardStatisticFranchise(
	action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardStatisticFranchiseResponse> =
			yield API.getWorkerDashboardStatisticFranchise(rest);
		const workerDashboardStatisticFranchise = res?.data;

		yield put(
			WorkerDashboardActions.getWorkerDashboardStatisticFranchiseSuccess(
				workerDashboardStatisticFranchise
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerDashboardActions.getWorkerDashboardStatisticFranchiseFailure()
		);
	}
}

export function* getWorkerDashboardStatisticApplicant(
	action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardStatisticApplicantResponse> =
			yield API.getWorkerDashboardStatisticApplicant(rest);
		const workerDashboardStatisticApplicant = res?.data;

		yield put(
			WorkerDashboardActions.getWorkerDashboardStatisticApplicantSuccess(
				workerDashboardStatisticApplicant
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerDashboardActions.getWorkerDashboardStatisticApplicantFailure()
		);
	}
}

export function* getWorkerDashboardUseTipList(
	action: PayloadAction<IPayloadGetWorkerDashboardUseTipListRequest>
) {
	const { callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardUseTipListResponse> =
			yield API.getWorkerDashboardUseTip();
		const content = formatWorkerDashboardUseTipList(res?.data);

		yield put(
			WorkerDashboardActions.getWorkerDashboardUseTipListSuccess({
				content,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDashboardActions.getWorkerDashboardUseTipListFailure());
	}
}

export function* getWorkerDashboardNoticeReceiveList(
	action: PayloadAction<IPayloadGetWorkerDashboardNoticeReceiveListRequest>
) {
	const { callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetDashboardNoticeReceiveListResponse> =
			yield API.getWorkerDashboardNoticeReceive();
		const content = formatWorkerDashboardNoticeReceiveList(res?.data);

		yield put(
			WorkerDashboardActions.getWorkerDashboardNoticeReceiveListSuccess({
				content,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerDashboardActions.getWorkerDashboardNoticeReceiveListFailure()
		);
	}
}
